import { Box, Typography } from "@mui/material";
import moment from "moment";

type EventDateTimeProps = {
    event: any;
    group: any;
    eventDetails?: boolean;
};

const EventDateTime: React.FC<EventDateTimeProps> = ({
    event,
    group,
    eventDetails = false,
}) => {
    const lang = document.documentElement.lang;

    if (
        (eventDetails && group.length === 0) ||
        (!eventDetails && group.length === 1)
    ) {
        let format = null;

        if (event.start_show_time) {
            if (event.end_show_time) {
                format = (
                    <Typography>
                        {moment(event.start_datetime)
                            .local()
                            .locale(lang === "en" ? "en-gb" : lang)
                            .format("ddd DD MMM")}
                        <br />
                        {moment(event.start_datetime)
                            .local()
                            .locale(lang === "en" ? "en-gb" : lang)
                            .format("HH:mm")}{" "}
                        -{" "}
                        {moment(event.end_datetime)
                            .local()
                            .locale(lang === "en" ? "en-gb" : lang)
                            .format("HH:mm")}
                    </Typography>
                );
            } else {
                format = (
                    <Typography>
                        {moment(event.start_datetime)
                            .local()
                            .locale(lang === "en" ? "en-gb" : lang)
                            .format("ddd DD MMM")}
                        <br />
                        {moment(event.start_datetime)
                            .local()
                            .locale(lang === "en" ? "en-gb" : lang)
                            .format("HH:mm")}
                    </Typography>
                );
            }
        } else {
            format = (
                <Typography>
                    {moment(event.start_datetime)
                        .local()
                        .locale(lang === "en" ? "en-gb" : lang)
                        .format("ddd DD MMM")}
                </Typography>
            );
        }

        return (
            <>
                <Typography
                    sx={{
                        fontFamily: "'Noto Sans', sans-serif",
                        fontWeight: 600,
                        fontSize: 16,
                    }}
                >
                    {format}
                </Typography>
            </>
        );
    } else {
        const startDateTime = moment(event.start_datetime)
            .local()
            .locale(lang === "en" ? "en-gb" : lang);

        const endDateTime = moment(group[group.length - 1].start_datetime)
            .local()
            .locale(lang === "en" ? "en-gb" : lang);
        const isSame = moment(startDateTime.format("YYYY")).isSame(
            endDateTime.format("YYYY")
        );

        return isSame ? (
            <>
                <Typography
                    sx={{
                        fontFamily: "'Noto Sans', sans-serif",
                        fontWeight: 600,
                        fontSize: 16,
                    }}
                >
                    {" "}
                    {startDateTime.format("DD.MM")}
                    {" - "}
                    {endDateTime.format("DD.MM")}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "'Noto Sans', sans-serif",
                        fontWeight: 600,
                        fontSize: 16,
                    }}
                >
                    {endDateTime.format("YYYY")}
                </Typography>
            </>
        ) : (
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    flexWrap: "wrap",
                }}
            >
                <Typography
                    sx={{
                        fontFamily: "'Noto Sans', sans-serif",
                        fontWeight: 600,
                        fontSize: 16,
                    }}
                >
                    {" "}
                    {startDateTime.format("DD.MM.YYYY")}{" "}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "'Noto Sans', sans-serif",
                        fontWeight: 600,
                        fontSize: 16,
                    }}
                >
                    - {endDateTime.format("DD.MM.YYYY")}
                </Typography>
            </Box>
        );
    }
};
export default EventDateTime;
